export default __webpack_public_path__ + "static/media/bg_08.424f7bcc.png";